import * as types from '../constants/actionTypes';
import api from '../../shared/api.json';
import uriTemplate from 'uri-template';
import validateProfile from '../../shared/validateProfile';

function getProfileUrl(id) {
    const uri = uriTemplate.parse(api.profiles.fetch).expand({ id });
    return uri;
}

function getEditableProfileUrl(id) {
    return uriTemplate.parse(api.profiles.editable).expand({ id });
}

function getCompanyAdsUrl(id) {
    const uri = uriTemplate.parse(api.profiles.fetchActiveAds).expand({ id });
    return uri;
}

export function fetchProfile(id) {
    return {
        types: [
            types.FETCH_PROFILE,
            types.FETCH_PROFILE_SUCCESS,
            types.FETCH_PROFILE_FAIL,
        ],
        promise: (client) => client.get(getProfileUrl(id)),
    };
}

export function fetchEditableProfile(id) {
    return {
        types: [
            types.FETCH_EDITABLE_PROFILE,
            types.FETCH_EDITABLE_PROFILE_SUCCESS,
            types.FETCH_EDITABLE_PROFILE_FAIL,
        ],
        promise: (client) => client.get(getEditableProfileUrl(id)),
    };
}

export function fetchCompanyAds(id) {
    return {
        types: [
            types.FETCH_COMPANY_ADS,
            types.FETCH_COMPANY_ADS_SUCCESS,
            types.FETCH_COMPANY_ADS_FAIL,
        ],
        promise: (client) => client.get(getCompanyAdsUrl(id)),
    };
}
export function filterCompanyAds(filter) {
    return {
        type: types.FILTER_COMPANY_ADS,
        filter,
    };
}

export function clickActiveAd(adId) {
    return {
        type: types.CLICK_ACTIVE_AD,
        adId,
    };
}

export function uploadBackground(id, data) {
    const url = uriTemplate.parse(api.profiles.uploadImage).expand({ id });

    return {
        types: [
            types.UPLOAD_PROFILE_BACKGROUND,
            types.UPLOAD_PROFILE_BACKGROUND_SUCCESS,
            types.UPLOAD_PROFILE_BACKGROUND_FAIL,
        ],
        promise: (client) =>
            client.post(url, { fileUpload: { file: data.file, fields: data } }),
    };
}

export function uploadLogo(id, data) {
    const url = uriTemplate.parse(api.profiles.uploadImage).expand({ id });

    return {
        types: [
            types.UPLOAD_PROFILE_LOGO,
            types.UPLOAD_PROFILE_LOGO_SUCCESS,
            types.UPLOAD_PROFILE_LOGO_FAIL,
        ],
        promise: (client) =>
            client.post(url, { fileUpload: { file: data.file, fields: data } }),
    };
}

export function updateField(id, data) {
    const url = uriTemplate.parse(api.profiles.fetch).expand({ id });

    const patchData = [
        {
            op: 'add',
            value: data.value,
            path: `/${data.name}`,
        },
    ];

    return {
        types: [
            types.UPDATE_FIELD,
            types.UPDATE_FIELD_SUCCESS,
            types.UPDATE_FIELD_FAIL,
        ],
        promise: (client) => client.put(url, { data: patchData }),
        meta: {
            name: data.name,
            value: data.value,
        },
    };
}

export function validateProfileErrors(profile) {
    const errors = validateProfile(profile);
    return { type: types.PROFILE_SET_ERRORS, errors };
}

export function publishProfile(profile) {
    const errors = validateProfile(profile);
    const id = profile.id;

    if (Object.keys(errors).length) {
        return {
            type: types.PROFILE_SET_ERRORS,
            errors,
        };
    } else {
        const url = uriTemplate
            .parse(api.profiles.publishProfile)
            .expand({ id });

        return [
            // publish
            {
                types: [
                    types.PUBLISH_PROFILE,
                    types.PUBLISH_PROFILE_SUCCESS,
                    types.PUBLISH_PROFILE_FAIL,
                ],
                promise: (client) => client.post(url),
            },

            // fetch newly created profile
            {
                types: [
                    types.FETCH_EDITABLE_PROFILE,
                    types.FETCH_EDITABLE_PROFILE_SUCCESS,
                    types.FETCH_EDITABLE_PROFILE_FAIL,
                ],
                promise: (client) => client.get(getEditableProfileUrl(id)),
            },
        ];
    }
}

export function unpublishProfile(profile) {
    const { id } = profile;

    const url = uriTemplate.parse(api.profiles.unpublishProfile).expand({ id });

    return [
        {
            types: [
                types.UNPUBLISH_PROFILE,
                types.UNPUBLISH_PROFILE_SUCCESS,
                types.UNPUBLISH_PROFILE_FAIL,
            ],
            promise: (client) => client.post(url),
        },
        {
            types: [
                types.FETCH_EDITABLE_PROFILE,
                types.FETCH_EDITABLE_PROFILE_SUCCESS,
                types.FETCH_EDITABLE_PROFILE_FAIL,
            ],
            promise: (client) => client.get(getEditableProfileUrl(id)),
        },
    ];
}
